import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import ConsultationModal from './ConsultationModal';
import logo from '../img/swlogo_site.png';

function Header() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const phoneNumber = '2017267342';

  const navLinks = [
    { to: '/', label: 'Home', end: true },
    { to: '/about', label: 'About' },
    { to: '/services', label: 'Services' },
    { to: '/contact', label: 'Contact' },
    { to: '/careers', label: 'Careers' },
  ];

  const closeMenu = () => setIsMenuOpen(false);

  const linkClass = ({ isActive }) =>
    `whitespace-nowrap transition-colors ${
      isActive
        ? 'text-primary-700 font-semibold'
        : 'text-ink-soft hover:text-primary-600'
    }`;

  return (
    <>
      <header className="fixed top-0 z-50 w-full border-b border-primary-100 bg-white">
        <nav className="container mx-auto px-4 py-2.5 sm:py-3">
          <div className="flex min-h-[5rem] items-center justify-between gap-4 lg:grid lg:min-h-[6rem] lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] lg:gap-8">
            <div className="hidden items-center justify-end gap-6 xl:gap-8 lg:flex">
              {navLinks.map((link) => (
                <NavLink key={link.to} to={link.to} end={link.end} className={linkClass}>
                  {link.label}
                </NavLink>
              ))}
            </div>

            <button
              type="button"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 text-ink-soft lg:hidden"
              aria-label="Toggle navigation menu"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((open) => !open)}
            >
              <span className="space-y-1.5">
                <span className="block h-0.5 w-5 bg-current"></span>
                <span className="block h-0.5 w-5 bg-current"></span>
                <span className="block h-0.5 w-5 bg-current"></span>
              </span>
            </button>

            <Link to="/" className="flex items-center justify-center bg-transparent" onClick={closeMenu}>
              <img
                src={logo}
                alt="Sheryl Williams Hair Replacement Med Spa"
                className="h-16 w-auto max-w-[17rem] bg-transparent object-contain sm:h-[4.5rem] sm:max-w-[21rem] lg:h-20 lg:max-w-[26rem]"
              />
            </Link>

            <div className="flex items-center justify-end gap-2 sm:gap-3">
              <a
                href={`tel:+1${phoneNumber}`}
                className="hidden rounded-full border border-primary-200 px-4 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50 md:inline-flex"
              >
                Call
              </a>
              <button
                type="button"
                className="btn-primary px-4 py-2.5 text-sm sm:px-6 sm:text-base"
                onClick={() => {
                  closeMenu();
                  setIsModalOpen(true);
                }}
              >
                Book Consultation
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="border-t border-gray-100 pb-4 pt-3 lg:hidden">
              <div className="grid gap-1">
                {navLinks.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    end={link.end}
                    className={({ isActive }) =>
                      `rounded-md px-3 py-3 transition-colors ${
                        isActive
                          ? 'bg-primary-50 font-semibold text-primary-700'
                          : 'text-ink-soft hover:bg-primary-50 hover:text-primary-700'
                      }`
                    }
                    onClick={closeMenu}
                  >
                    {link.label}
                  </NavLink>
                ))}
                <a
                  href={`tel:+1${phoneNumber}`}
                  className="rounded-md px-3 py-3 font-semibold text-primary-700"
                  onClick={closeMenu}
                >
                  Call (201) 726-7342
                </a>
              </div>
            </div>
          )}
        </nav>
      </header>

      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default Header;
